import { render, staticRenderFns } from "./CreateSocialMedia.vue?vue&type=template&id=315cc210&scoped=true&"
import script from "./CreateSocialMedia.vue?vue&type=script&lang=js&"
export * from "./CreateSocialMedia.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=315cc210&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315cc210",
  null
  
)

export default component.exports